import { gql, OperationVariables, QueryResult } from '@apollo/client';
import { fromNullable, none } from 'fp-ts/Option';

import { useLazyGraphql, EnhancedLazyGraphqlResult } from 'utils/hooks/useLazyGraphql';
import { NBADataResponse } from 'modules/ai/nba/types';

export const fetchCampaignNBA = gql`
  query getNextBestActionForCampaign($campaignId: Long!) {
    getNextBestActionForCampaign(campaignId: $campaignId) {
      audienceCount
      topCampaigns {
        campaignId
        moodText
      }
      suggestions {
        suggestionText
        moodText
      }
    }
  }
`;

export const transformToNBAQuery = (
  queryNBAResult:
    | EnhancedLazyGraphqlResult<NBADataResponse, OperationVariables>
    | QueryResult<NBADataResponse, OperationVariables>,
) => {
  return {
    previousData: queryNBAResult.previousData
      ? fromNullable(queryNBAResult.previousData.getNextBestActionForCampaign)
      : none,
    data: queryNBAResult.error
      ? none
      : fromNullable(queryNBAResult.data?.getNextBestActionForCampaign),
    isError: queryNBAResult.error,
  };
};

export const useNBAQuery = (campaignId: string) => {
  return useLazyGraphql<NBADataResponse>(fetchCampaignNBA, {
    variables: {
      campaignId,
    },
  });
};
